import DataElements from './dataElement';

export default [
  DataElements.VIEW_CONTROLS_OVERLAY,
  DataElements.SEARCH_OVERLAY,
  DataElements.MENU_OVERLAY,
  DataElements.ZOOM_OVERLAY,
  DataElements.TOOLS_OVERLAY,
  DataElements.STAMP_OVERLAY,
  DataElements.SIGNATURE_OVERLAY,
  DataElements.MEASUREMENT_OVERLAY,
  DataElements.TOOL_STYLE_POPUP,
  DataElements.THUMBNAILS_CONTROL_MANIPULATE_POPUP_SMALL,
  DataElements.THUMBNAILS_CONTROL_MANIPULATE_POPUP
];